import { render, staticRenderFns } from "./PackingSelection.vue?vue&type=template&id=65a06ef9&"
import script from "./PackingSelection.vue?vue&type=script&lang=js&"
export * from "./PackingSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports